import React, { forwardRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@fast-ai/ui-components';

import { UlContext } from './context';

const List = forwardRef(({ sx, inline, ...rest }, ref) => {
	const contextValue = useMemo(() => ({ inline }), [inline]);
	return (
		<UlContext.Provider value={contextValue}>
			<Box
				ref={ref}
				as="ul"
				sx={{
					listStyle: 'none',
					mx: 0,
					px: 0,
					...sx,
				}}
				{...rest}
			/>
		</UlContext.Provider>
	);
});

List.propTypes = {
	inline: PropTypes.bool,
};

List.displayName = 'List';

export default List;
